import { defineComponent, createElementBlock, createCommentVNode, openBlock, createElementVNode, Fragment, renderList, createBlock, withCtx, createTextVNode, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es121.js';
import { ourMD5 } from './basler-components.es376.js';

const _hoisted_1 = {
  key: 0,
  class: "nav-footer"
};
const _hoisted_2 = { class: "nav-footer__list is-level-01" };
const _hoisted_3 = { class: "nav-footer__headline" };
const _hoisted_4 = {
  key: 1,
  class: "nav-footer__entry is-level-01"
};
const _hoisted_5 = ["id", "aria-controls", "onClick"];
const _hoisted_6 = ["id", "aria-labelledby"];
const _hoisted_7 = { class: "nav-footer__panel-inner" };
const _hoisted_8 = { class: "nav-footer__list is-level-02" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NavFooter",
  props: {
    items: {}
  },
  setup(__props) {
    const props = __props;
    const itemIds = [];
    const generateId = (key) => {
      if (itemIds[key]) {
        return itemIds[key];
      }
      itemIds[key] = ourMD5(key);
      return itemIds[key];
    };
    const onTriggerClick = (selectorId) => {
      const triggerBtn = document.getElementById(`accordion-trigger-${selectorId}`);
      const panel = document.getElementById(`accordion-panel-${selectorId}`);
      if (triggerBtn && panel) {
        const isExpanded = triggerBtn.getAttribute("aria-expanded") === "true";
        triggerBtn.setAttribute("aria-expanded", String(!isExpanded));
        panel.classList.toggle("is-active");
      }
    };
    return (_ctx, _cache) => {
      return Array.isArray(props.items) && props.items.length > 0 ? (openBlock(), createElementBlock("nav", _hoisted_1, [
        createElementVNode("ul", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (navItem, index) => {
            return openBlock(), createElementBlock("li", {
              key: `${index}-${navItem.text}`,
              class: "nav-footer__list-item is-level-01"
            }, [
              createElementVNode("div", _hoisted_3, [
                navItem.link && navItem.link.uri ? (openBlock(), createBlock(_sfc_main$1, {
                  key: 0,
                  uri: navItem.link.uri,
                  rel: navItem.link.rel,
                  target: navItem.link.target,
                  class: "nav-footer__entry is-level-01"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(navItem.text), 1)
                  ]),
                  _: 2
                }, 1032, ["uri", "rel", "target"])) : (openBlock(), createElementBlock("span", _hoisted_4, toDisplayString(navItem.text), 1)),
                createElementVNode("button", {
                  id: `accordion-trigger-${generateId(`${index}-${navItem.text}`)}`,
                  role: "button",
                  class: "nav-footer__acc-trigger",
                  "aria-controls": `accordion-panel-${generateId(`${index}-${navItem.text}`)}`,
                  "aria-expanded": false,
                  onClick: ($event) => onTriggerClick(generateId(`${index}-${navItem.text}`))
                }, _cache[0] || (_cache[0] = [
                  createElementVNode("span", { class: "visually-hidden" }, "Toggle accordion item", -1)
                ]), 8, _hoisted_5)
              ]),
              Array.isArray(navItem.items) && navItem.items.length > 0 ? (openBlock(), createElementBlock("div", {
                key: 0,
                id: `accordion-panel-${generateId(`${index}-${navItem.text}`)}`,
                role: "region",
                class: "nav-footer__panel",
                "aria-labelledby": `accordion-trigger-${generateId(`${index}-${navItem.text}`)}`
              }, [
                createElementVNode("div", _hoisted_7, [
                  createElementVNode("ul", _hoisted_8, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(navItem.items, (subNavItem, index2) => {
                      return openBlock(), createElementBlock("li", {
                        key: `${index2}-${subNavItem.text}`,
                        class: "nav-footer__list-item is-level-02"
                      }, [
                        subNavItem.link && subNavItem.link.uri ? (openBlock(), createBlock(_sfc_main$1, {
                          key: 0,
                          uri: subNavItem.link.uri,
                          rel: subNavItem.link.rel,
                          target: subNavItem.link.target,
                          class: "nav-footer__entry is-level-02"
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(subNavItem.text), 1)
                          ]),
                          _: 2
                        }, 1032, ["uri", "rel", "target"])) : createCommentVNode("", true)
                      ]);
                    }), 128))
                  ])
                ])
              ], 8, _hoisted_6)) : createCommentVNode("", true)
            ]);
          }), 128))
        ])
      ])) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
